import React from 'react';
import { render } from 'react-dom';

import App from './App';

import 'client/styles/app.scss';

render(<App />, document.getElementById('app-render-root'));
